import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import getReduxLanguageDetector from './redux-language-detector';
import { supportedLocales } from "./locales";

const baseUrl = process.env.PUBLIC_URL && process.env.PUBLIC_URL !== '/' ? process.env.PUBLIC_URL : '';

// Use versioned files only in production to maintain hot reloading in development
let loadPath;
if (process.env.NODE_ENV === 'production') {
  try {
    const { LOCALE_HASH } = require('./locale-hash');
    loadPath = baseUrl + `/locales/%{lng}/%{ns}.${LOCALE_HASH}.json`;
  } catch (e) {
    // Fallback if locale-hash doesn't exist
    loadPath = baseUrl + '/locales/%{lng}/%{ns}.json';
  }
} else {
  // Development: use static path for hot reloading
  loadPath = baseUrl + '/locales/%{lng}/%{ns}.json';
}


export const initI18nWithStore = (store) => {
  const languageDetector = new LanguageDetector();
  const reduxLanguageDetector = getReduxLanguageDetector(store);
  languageDetector.addDetector(reduxLanguageDetector);
  
  i18n
    .use(initReactI18next)
    .use(Backend)
    .use(languageDetector) // Browser detector as fallback
    .init({
      backend: {
          loadPath: loadPath
      },

      fallbackLng: "en",

      interpolation: {
        escapeValue: false,
        prefix: '%{',
        suffix: '}'
      },

      keySeparator: false,

      load: 'languageOnly',

      whitelist: ['en', ...supportedLocales],

      detection: { checkWhitelist: true, order: ['reduxLanguageDetector','querystring', 'hash', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'] },

      react: {
          useSuspense: false
      }
    });
    
    return [i18n, languageDetector];
};

export default initI18nWithStore;